import React, { useEffect, useState } from 'react';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import closeIcon from '../../../../assets/images/close-icon-02.png';

type IProps = {
  handleCloseEvent: () => void;
  url: string;
};

interface file {
  url: string | undefined | null;
}

const MyDocumentViewer = (props: IProps) => {
  const file = {
    url: props?.url || '',
  };

  const [docs, setDocs] = useState<file[]>([file]);
  const [currentFileType, setCurrentFileType] = useState<string>('');
  const [isGoogleForm, setIsGoogleForm] = useState<boolean>(false);

  const setTheUrlLink = () => {
    if (props?.url !== undefined) {
      let arrAddUrl: any[] = [];
      arrAddUrl.push({
        url: props?.url,
      });
      setDocs(arrAddUrl);
    }
  };

  const getFileType = (strFileName: string = '') => {
    if (strFileName.includes('docs.google.com/forms')) {
      setIsGoogleForm(true);
      setCurrentFileType('gform');
      return;
    } else {
      setIsGoogleForm(false);
    }

    let strFileType: string = '';
    let arrFileType: any[] = [];
    let arrExisting: any[] = strFileName?.split('');
    for (let i = arrExisting.length - 1; i >= 0; i--) {
      if (arrExisting[i].includes('.')) break;
      arrFileType.unshift(arrExisting[i]);
    }
    strFileType = arrFileType.join('').trim();
    setCurrentFileType(strFileType);
  };

  useEffect(() => {
    setTheUrlLink();
    getFileType(props?.url);
  }, [props?.url]);

  return (
    <div id="video_screen_id" className="center_container marginPadding_zero">
      <div className='relative'>
        <button
          onClick={props.handleCloseEvent}
          className="absolute right-0 top-1/2 -translate-y-1/2 mobile:-right-8 tablet:-right-10 laptop:-right-12 desktop:-right-14 z-10"
        >
          <img
            src={closeIcon}
            alt="Close"
            className="h-[4vh] w-[4vh] mobile:h-[3vh] mobile:w-[3vh] tablet:h-[3.5vh] tablet:w-[3.5vh] laptop:h-[4vh] laptop:w-[4vh] desktop:h-[4.5vh] desktop:w-[4.5vh] object-contain"
          />
        </button>
      </div>
      <div
        className="col"
        style={{
          height: 'calc(70vh)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isGoogleForm ? (
          <iframe
            src={props.url}
            className='mobile:h-[70vh] mobile:w-[100%] tablet:h-[70vh] tablet:w-[100%] laptop:h-[70vh] laptop:w-[100%] desktop:h-[70vh] desktop:w-[100%]'
            width="100%"
            height="600px"
            style={{ border: 'none', marginTop: 'calc(5vh + 5px)', }}
            allow="camera; microphone; display-capture; fullscreen"
          ></iframe>
        ) : currentFileType === 'pdf' ? (
          <DocViewer
            config={{
              header: {
                disableHeader: true,
                disableFileName: false,
                retainURLParams: false,
              },
            }}
            documents={[{ uri: props?.url || '' }]}
            pluginRenderers={DocViewerRenderers}
          />
        ) : (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${docs[0]?.url}`}
            width="100%"
            height="600px"
          ></iframe>
        )}
      </div>
    </div>
  );
};
export default MyDocumentViewer;